import styled from 'styled-components'

export const Wrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(180deg, #f5f7fb 0%, #ffffff 48%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`

export const Content = styled.div`
  height: 100%;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 16px;
  padding: 24px;

  @media (min-width: 480px) {
    width: 100%;
  }
`

export const SweepstakeCard = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: 120px;
  border-radius: 16px;
  background: white;
  border: 1px solid rgba(14, 30, 37, 0.06);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
  transition: box-shadow 0.25s ease, transform 0.25s ease;
  overflow: hidden;

  &:hover {
    box-shadow: 0 16px 30px rgba(15, 23, 42, 0.12);
    transform: translateY(-2px);
    cursor: pointer;
  }
`
export const SweepstakeCardHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: 20px 20px 12px;
`

export const SweepstakeCardBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 14px;
  padding: 8px 20px 20px;
`

export const SweepstakeCardLuckyNumber = styled.div<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 8px 14px;
  min-height: 36px;
  min-width: 64px;
  border-radius: 10px;
  background-color: #f5d068;
  color: #2b1b0b;
  font-weight: 800;
  font-size: 14px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  border: 1px solid #e2b74d;

  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    width: 12px;
    height: 12px;
    background: #f7f7f8;
    border-radius: 50%;
    transform: translateY(-50%);
  }

  &::before {
    left: -6px;
  }

  &::after {
    right: -6px;
  }

  &:hover {
    transform: translateY(-1px);
  }

  ${p =>
    p.$active
      ? `
    border-color: #c88719;
    transform: translateY(-2px);
  `
      : ''}
`
export const SweepstakeCardLuckyNumberContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  background-color: #f7f7f8;
  width: 100%;
  padding: 14px 16px;
  border-radius: 12px;
`

export const SweepstakeCardHeaderIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: linear-gradient(135deg, #fff1c7 0%, #ffe28f 100%);
  padding: 8px;
`
export const SweepstakeCardHeaderText = styled.div`
  font-size: 18px;
  font-weight: 800;
  color: #1a1a1a;
  line-height: 1.2;
`

export const PageHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 6px;
  margin-bottom: 6px;
`

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
`

export const PageSubtitle = styled.p`
  margin: 0;
  font-size: 14px;
  color: #64748b;
`

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
`

export const CardDescription = styled.p`
  margin: 0;
  font-size: 13px;
  color: #6b7280;
`

export const CardMetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  color: #475569;
`

export const CardDates = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`

export const LuckyNumbersRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`

export const SectionLabel = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`

type StatusVariant = 'canceled' | 'active' | 'inactive' | 'finished'

const statusStyles: Record<
  StatusVariant,
  { background: string; color: string }
> = {
  canceled: { background: '#feecec', color: '#b91c1c' },
  active: { background: '#e7f8ef', color: '#0f8a4b' },
  inactive: { background: '#fff4e5', color: '#b45309' },
  finished: { background: '#808080', color: '#ffffff' },
}

export const StatusBadge = styled.span<{ $variant: StatusVariant }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  background: ${p => (statusStyles[p.$variant] ?? statusStyles.inactive).background};
  color: ${p => (statusStyles[p.$variant] ?? statusStyles.inactive).color};
`

export const EmptyState = styled.div`
  width: 100%;
  background: white;
  border-radius: 14px;
  padding: 32px;
  text-align: center;
  color: #64748b;
  border: 1px dashed rgba(15, 23, 42, 0.12);
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`

export const ModalHeaderStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: #0f172a;
`

export const ModalSubtitle = styled.p`
  margin: 0;
  font-size: 13px;
  color: #64748b;
`

export const ModalSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 16px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: #f8fafc;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 10px;
  padding: 10px 12px;
`

export const InfoLabel = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`

export const InfoValue = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
`

export const TicketsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`

export const TicketExpanded = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  border-radius: 12px;
  background: #fff8e1;
  border: 1px dashed #e2b74d;
  color: #7a4d00;
  font-size: 13px;
`

export const ModalDivider = styled.div`
  height: 1px;
  width: 100%;
  background: rgba(15, 23, 42, 0.08);
`

export const TicketModal = styled.div`
  position: relative;
  background: linear-gradient(135deg, #f7d36d 0%, #f2c14f 100%);
  border-radius: 18px;
  padding: 22px 24px;
  border: 2px solid #e0a93a;
  box-shadow: 0 18px 30px rgba(122, 74, 0, 0.25);
  overflow: hidden;
`

export const TicketPerforation = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 86px;
  width: 0;
  border-right: 2px dashed rgba(124, 70, 0, 0.35);
`

export const TicketStubs = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 86px;
  background: linear-gradient(180deg, #f8d772 0%, #efb945 100%);
  border-left: 2px solid #e0a93a;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TicketStubText = styled.div`
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 1px;
  color: #6f3f00;
`

export const TicketNumber = styled.div`
  font-size: 40px;
  font-weight: 900;
  letter-spacing: 2px;
  color: #5c2f00;
`

export const TicketTitle = styled.div`
  font-size: 16px;
  font-weight: 800;
  color: #6b3a00;
  text-transform: uppercase;
  letter-spacing: 1px;
`

export const TicketMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #6b3a00;
`

export const TicketHole = styled.span`
  position: absolute;
  width: 16px;
  height: 16px;
  background: #fff7e1;
  border: 1px solid #6b3a00;
  border-radius: 50%;
`

export const TicketHoleTop = styled(TicketHole)`
  top: 16px;
  left: -8px;
`

export const TicketHoleBottom = styled(TicketHole)`
  bottom: 16px;
  left: -8px;
`

export const TicketBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-right: 96px;
`

export const ModalPrizeItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`
export const ModalPrizeItemImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
`
export const RegulationButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  color: #64748b;
  font-size: 13px;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 8px;
  &:hover {
    text-decoration: none;
    transform: translateY(-1px);
    background-color: #f0f9ff;
  }
`

export const RegulationLink = styled.a`
  display: flex;
  align-items: start;
  justify-content: start;
  gap: 6px;
  color: #1a73e8;
  font-size: 13px;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;

  :hover {
    text-decoration: none;
    color: #1556a5;
  }
`
